import { render, staticRenderFns } from "./ApprovalCommentReject.vue?vue&type=template&id=df1bd226&"
import script from "./ApprovalCommentReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalCommentReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports